export default {
    tenant: null,
    users: [],
    invoices: [],
    coupon: '',
    yearlyPrice: 0,
    monthlyPrice: 0,
    totalYearlyPrice: 0,
    totalMonthlyPrice: 0
}
